'use client';

import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

const Content = () => {
  const t = useTranslations();

  return (
    <>
      <Typography Element="h1" variant="h3" className="mb-8">
        {t('impressum_page_title')}
      </Typography>

      <ul>
        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <Typography Element="span" className="block font-bold">
            {t('impressum_label_business_name')}:
          </Typography>
          <Typography Element="span">Oura Health Oy</Typography>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <Typography Element="span" className="block font-bold">
            {t('impressum_label_business_address')}:
          </Typography>
          <Typography Element="span" className="block">
            Elektroniikkatie 10, 90590 Oulu
          </Typography>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <Typography Element="span" className="block font-bold">
            {t('impressum_label_phone_number')}:
          </Typography>
          <Typography Element="span" className="block">
            +358 102816446
          </Typography>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <Typography Element="span" className="block font-bold">
            {t('impressum_label_email_address')}:
          </Typography>
          <Typography Element="span" className="block">
            <a href="mailto:info@ouraring.com">info@ouraring.com</a>
          </Typography>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <Typography Element="span" className="block font-bold">
            {t('impressum_label_registration_number')}:
          </Typography>
          <Typography Element="span" className="block">
            2542776-4
          </Typography>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <Typography Element="span" className="block font-bold">
            {t('impressum_label_vat_id_number')}:
          </Typography>
          <Typography Element="span" className="block">
            FI25427764
          </Typography>
        </div>
      </ul>
    </>
  );
};

export default Content;
